<template>
  <b-card>
    <b-card-header class="bg-info">
      <h4 class="title">تنظیمات سامانه پیامک</h4>
    </b-card-header>
    <b-card-body>
      <b-tabs
          ref="tabs"
          pills
          lazy
      >
        <b-tab
            title="سامانه پیامک"
        >
          <b-overlay
              :show="onProgress"
          >
            <b-form @submit.prevent>
              <b-row>
                <b-col cols="6">
                  <b-form-group>
                    <label for="smsSystem.sms_api">
                      <feather-icon
                          icon="FeatherIcon"
                      />
                      وب سرویس پیامک
                    </label>
                    <b-form-input
                        id="smsSystem.sms_api"
                        v-model="smsSystem.sms_api"
                        placeholder="وب سرویس پیامک را وارد نمایید"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group>
                    <label for="smsSystem.sms_number">
                      <feather-icon
                          icon="FeatherIcon"
                      />
                      شماره سامانه
                    </label>
                    <b-form-input
                        id="smsSystem.sms_number"
                        v-model="smsSystem.sms_number"
                        placeholder="شماره سامانه را وارد نمایید"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group>
                    <label for="smsSystem.call_api">
                      <feather-icon
                          icon="FeatherIcon"
                      />
                      وب سرویس تماس
                    </label>
                    <b-form-input
                        id="smsSystem.call_api"
                        v-model="smsSystem.call_api"
                        placeholder="وب سرویس تماس را وارد نمایید"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
            <button class="btn btn-info" @click="updateSetting">ذخیره تنظیمات</button>
          </b-overlay>

        </b-tab>
        <b-tab
            title="پیامک های سیستم"
        >
          <b-overlay
              :show="onProgress"
          >
            <b-form @submit.prevent>
              <b-row>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{title}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="تأیید درخواست"
                        v-model="smsSystem.accept_request_sms"
                    />
                    <label for="label-textarea">تأیید درخواست</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{title}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="بررسی درخواست"
                        v-model="smsSystem.check_request_sms"
                    />
                    <label for="label-textarea">بررسی درخواست</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{title}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="بازنگری درخواست"
                        v-model="smsSystem.review_request_sms"
                    />
                    <label for="label-textarea">بازنگری درخواست</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{title}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="رد درخواست"
                        v-model="smsSystem.reject_request_sms"
                    />
                    <label for="label-textarea">رد درخواست</label>
                  </div>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{title}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="دعوت به جلسه"
                        v-model="smsSystem.invite_agenda_sms"
                    />
                    <label for="label-textarea">دعوت به جلسه</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{title}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="ویرایش اطلاعات جلسه"
                        v-model="smsSystem.edit_agenda_sms"
                    />
                    <label for="label-textarea">ویرایش اطلاعات جلسه</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{title}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="لغو جلسه"
                        v-model="smsSystem.cancel_agenda_sms"
                    />
                    <label for="label-textarea">لغو جلسه</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{title}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="حذف اعضای جلسه"
                        v-model="smsSystem.delete_agenda_member_sms"
                    />
                    <label for="label-textarea">حذف اعضای جلسه</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{name}</code> , <code>{start_at}</code> , <code>{end_at}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="درخواست اتاق جلسه"
                        v-model="smsSystem.room_requested"
                    />
                    <label for="label-textarea">درخواست اتاق جلسه</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{name}</code> , <code>{start_at}</code> , <code>{end_at}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="تأیید درخواست اتاق جلسه"
                        v-model="smsSystem.room_accepted"
                    />
                    <label for="label-textarea">تأیید درخواست اتاق جلسه</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{name}</code> , <code>{start_at}</code> , <code>{end_at}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="رد درخواست اتاق جلسه توسط ادمین"
                        v-model="smsSystem.room_rejected"
                    />
                    <label for="label-textarea">رد درخواست اتاق جلسه توسط ادمین</label>
                  </div>
                </b-col>
                <b-col cols="6">
                  <p class="card-text"><span>پارامتر های قابل قبول :  </span><code>{name}</code> , <code>{start_at}</code> , <code>{end_at}</code></p>
                  <div class="form-label-group">
                    <b-form-textarea
                        id="textarea"
                        rows="3"
                        placeholder="لغو درخواست اتاق جلسه توسط درخواست دهنده"
                        v-model="smsSystem.room_canceled"
                    />
                    <label for="label-textarea">لغو درخواست اتاق جلسه توسط درخواست دهنده</label>
                  </div>
                </b-col>

              </b-row>
            </b-form>
            <button class="btn btn-info" type="submit" @click="updateSetting">ذخیره تنظیمات</button>
          </b-overlay>

        </b-tab>

      </b-tabs>

    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay, BTabs, BTab, BButton, BFormCheckbox, BNavItem, BBadge, BFormTextarea
} from 'bootstrap-vue'
import {$themeConfig} from "@themeConfig";
import Vue2OrgTree from "@/views/components/org-tree/org-tree.vue";
import VSelect from "vue-select";

export default {
  name: 'UserGroup_Create',
  components: {
    BBadge, VSelect, Vue2OrgTree, BNavItem, BFormCheckbox, BButton, BTab, BTabs,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BFormTextarea
  },
  data() {
    return {
      onProgress: false,
      smsSetting: {},
      smsSystem: {
        sms_api: null,
        sms_number: null,
        call_api: null
      }
    }
  },
  methods: {
    getSmsSettings() {
      this.$http.get('settings')
          .then(({data}) => {
            if (data.status) {
             this.smsSystem = data.settings

              this.onProgress = false
            } else {
              this.$bvToast.toast('در دریافت تنظیمات خطایی رخ داده', {
                title: 'حطا',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch((error) => {
            this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger'
            })
          })
    },
    async updateSetting() {
      console.log(this.smsSystem.sms_number)
      if (this.smsSystem.sms_number) {
        const regex = /^\d{6,14}$/
        if (!this.smsSystem.sms_number.match(regex)) {
          this.$bvToast.toast('شماره سامانه باید به ص.رت یک عدد ۶ تا ۱۴ رقمی باشد', {
            title: 'خطا',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
          return
        }
      }
      this.onProgress = true
      await this.$http.post('settings', this.smsSystem)
          .then(({data}) => {
            if (data.status) {
              this.$bvToast.toast('تنظیمات با موفقیت ثبت شد', {
                title: 'انجام درخواست',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'success',
              })
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست دریافت کنندگان با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
      this.onProgress = false
    }
  },
  mounted() {
    this.getSmsSettings()
  }
}
</script>

<style>

</style>